// extracted by mini-css-extract-plugin
export default {"section":"index_section__WAa7r","option":"index_option__+G39e","left":"index_left__xskHX","right":"index_right__ylULn","add":"index_add__BVCml"};